import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Button,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";

// El worker vive en /public para que CRA no lo tenga que bundlear
pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;

// Salto vertical que separa parrafos dentro de la celda PRODUCTO del PDF de MeLi:
// las lineas del mismo parrafo van a ~9 y el siguiente parrafo arranca a ~11
const GAP_PARRAFO_PDF = 10.5;

function TraspasosSalidaCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_TRASPASOS_SALIDA = process.env.REACT_APP_URL_TRASPASOS_SALIDA;
  const URL_TRASPASOS_ENTRADA = process.env.REACT_APP_URL_TRASPASOS_ENTRADA;
  const URL_ARTICULOS_TS = process.env.REACT_APP_URL_ARTICULOS_TS;
  const URL_ARTICULOS_TE = process.env.REACT_APP_URL_ARTICULOS_TE;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const AREAS_GENERAL = process.env.REACT_APP_AREAS_GENERAL;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [inventarios, setInventarios] = useState([]);

  const [areas, setAreas] = useState([]);
  const [selectedAreaSalida, setSelectedAreaSalida] = useState("");
  const [selectedAreaDestino, setSelectedAreaDestino] = useState("");

  const [fecha, setFecha] = useState(hoy);
  const [fechaRecoleccion, setFechaRecoleccion] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [total, setTotal] = useState(0);
  const [total_cantidad, setTotalCantidad] = useState(0);
  const [cargando, setCargando] = useState(false);

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      inventarioId: "",
      piezasPorCaja: 0,
      cajas: 0,
      cantidad: 0,
      precio: 0,
      costoUnitario: 0,
      lote: "NA",
      total: 0,
      disponible: 0,
      infoAdicional: "NA",
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);

  const Toast = Swal.mixin({
    toast: true,
    position: "center",
    showConfirmButton: false,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });
  if (cargando) {
    Toast.fire({
      html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`,
      title: "Danos unos segundos....",
      customClass: {
        icon: "animated-icon",
      },
    });
  }

  useEffect(() => {
    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        setAreas(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
console.log("hola", inputFields)
  const saveTraspaso = async (event) => {
    event.preventDefault();

    if (selectedAreaDestino === selectedAreaSalida) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Los almacenes de Salida y Destino No pueden ser iguales",
      });
      return;
    }

    if (!selectedAreaSalida || !selectedAreaDestino) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Selecciona Almacén de Salida y Almacén Destino",
      });
      return;
    }

    const articulosValidos = inputFields.filter(
      (a) => a.articulos !== "" && parseFloat(a.cantidad) > 0
    );

    if (articulosValidos.length === 0) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Agrega al menos un artículo con cantidad mayor a 0",
      });
      return;
    }

    setValidaBoton(false);
    toggleProgreso();

    // Ya no se bloquea por disponible: lo que no alcanza sale y el almacen queda en negativo; se avisa
    // al final para hacer el ajuste
    const enNegativo = articulosValidos
      .filter((a) => parseFloat(a.cantidad) > (parseFloat(a.disponible) || 0))
      .map((a) => `${a.sku || ""}: ${parseFloat(a.disponible) || 0} - ${a.cantidad} = ${(parseFloat(a.disponible) || 0) - parseFloat(a.cantidad)}`);

    try {
      const salidaResp = await axios.post(
        URL_TRASPASOS_SALIDA,
        {
          fecha,
          fechaRecoleccion: fechaRecoleccion || "NA",
          areaSalida: selectedAreaSalida,
          areaDestino: selectedAreaDestino,
          observaciones,
          total: parseFloat(total_cantidad),
          recibida: "Si",
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );
      const salidaId = salidaResp.data._id;

      const entradaResp = await axios.post(
        URL_TRASPASOS_ENTRADA,
        {
          fecha,
          traspasosSalida: salidaId,
          total: parseFloat(total_cantidad),
          observaciones,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );
      const entradaId = entradaResp.data._id;

      for (const a of articulosValidos) {
        await axios.post(
          URL_ARTICULOS_TS,
          {
            traspasosSalida: salidaId,
            inventarios: a.inventarioId,
            articulos: a.articulos,
            areas: selectedAreaSalida,
            cantidad: parseFloat(a.cantidad),
            fecha,
            recibida: "Si",
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );

        await axios.post(
          URL_ARTICULOS_TE,
          {
            traspasosEntrada: entradaId,
            areaDestino: selectedAreaDestino,
            areas: selectedAreaDestino,
            articulos: a.articulos,
            cantidad: parseFloat(a.cantidad),
            lote: a.lote || "NA",
            costoUnitario: parseFloat(a.costoUnitario) || 0,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
      }

      await axios.post(
        URL_LOGS,
        {
          tipo: "Crear Traspaso Salida",
          detalle: `${salidaId} ${total}`,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      if (enNegativo.length) {
        await Swal.fire({
          icon: "warning",
          title: "Traspaso creado",
          html:
            `${enNegativo.length} artículo(s) quedaron en negativo en el almacén de salida, haz el ajuste:` +
            `<p style="text-align:left;margin-top:10px">${enNegativo.slice(0, 30).join("<br>")}${enNegativo.length > 30 ? "<br>..." : ""}</p>`,
        });
        window.location.reload();
      } else {
        Swal.fire("Good job!", "Traspaso creado con éxito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response?.data?.message || error.response?.data || error.message}`,
      });
      console.log(error);
      setValidaBoton(true);
      setModalProgreso(false);
    }
  };

  function jalaAlmacenSalida(e) {
    setSelectedAreaSalida(e);
    setCargando(true);

    axios
      .get(`${URL_INVENTARIOS}SurtirTraspasos/${e}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        setInventarios(response.data);
        setCargando(false);
        Toast.close();
      })
      .catch((err) => {
        console.log(err);
        setCargando(false);
      });

    setInputFields([
      {
        id: uuidv4(),
        articulos: "",
        inventarioId: "",
        piezasPorCaja: 0,
        cajas: 0,
        cantidad: 0,
        precio: 0,
        costoUnitario: 0,
        lote: "NA",
        total: 0,
        disponible: 0,
        infoAdicional: "NA",
      },
    ]);
  }

  // Lee el PDF "Listado de productos e instrucciones de preparacion" de MeLi Full.
  // La tabla trae PRODUCTO (con el SKU) en la columna izquierda y UNIDADES a media
  // pagina, asi que los renglones se arman por coordenadas: cada numero suelto de
  // la columna UNIDADES ancla un renglon y se le pegan las lineas de PRODUCTO que
  // caen en su banda vertical.
  async function leerRenglonesPDF(data) {
    const doc = await pdfjsLib.getDocument({ data }).promise;
    const filas = [];

    for (let p = 1; p <= doc.numPages; p++) {
      const page = await doc.getPage(p);
      const content = await page.getTextContent();

      const items = content.items
        .filter((it) => it.str && it.str.trim())
        .map((it) => ({ x: it.transform[4], y: it.transform[5], s: it.str }));

      // Solo los numeros alineados con el encabezado UNIDADES: el PDF trae numeros sueltos un poco
      // corridos a la derecha (38, 14...) que no son cantidades y partian los renglones
      const encabezado = items.find((it) => it.s.trim().toUpperCase() === "UNIDADES");
      const unidades = items
        .filter(
          (it) =>
            /^\d+$/.test(it.s.trim()) &&
            (encabezado ? Math.abs(it.x - encabezado.x) < 1.5 : it.x > 150 && it.x < 290)
        )
        .sort((a, b) => b.y - a.y);

      const producto = items.filter((it) => it.x < 150).sort((a, b) => b.y - a.y);

      unidades.forEach((u, i) => {
        const yTop = u.y + 12;
        const yBot = i + 1 < unidades.length ? unidades[i + 1].y + 12 : -Infinity;
        const lineas = producto.filter((it) => it.y < yTop && it.y >= yBot);
        if (!lineas.length) return;

        // El SKU arranca despues de "SKU:" y sigue bajando de renglon hasta que
        // corta el parrafo: dentro del bloque el salto vertical es ~9 y la
        // descripcion arranca a ~11
        let skuPegado = "";
        let skuConEspacio = "";
        const iSKU = lineas.findIndex((l) => /SKU:/i.test(l.s));
        if (iSKU >= 0) {
          const linea = lineas[iSKU].s;
          const resto = linea.slice(linea.toUpperCase().lastIndexOf("SKU:") + 4).trim();
          skuPegado = resto;
          skuConEspacio = resto;
          for (let j = iSKU + 1; j < lineas.length; j++) {
            if (lineas[j - 1].y - lineas[j].y > GAP_PARRAFO_PDF) break;
            const frag = lineas[j].s.trim();
            if (!frag) continue;
            // sin separador: el PDF solo parte a media palabra cuando no hay espacio
            skuPegado = skuPegado ? skuPegado + frag : frag;
            skuConEspacio = skuConEspacio ? skuConEspacio + " " + frag : frag;
          }
        }

        const txt = lineas.map((l) => l.s);
        filas.push({
          cantidad: parseInt(u.s, 10),
          sku: skuPegado,
          skuAlt: skuConEspacio,
          blob: txt.join(""),
          blobSp: txt.join(" "),
        });
      });
    }
    return filas;
  }

  // /inventariosSurtirTraspasos regresa el SKU en "codigo", igual que lo lee el Autocomplete
  const skuDeInv = (inv) => (inv && (inv.SKU || inv.codigo)) || "";

  // El renglon del master es la suma de sus variantes (no es un registro de inventario): se surte de
  // su variante. Con una sola, esa; con varias, la de piezas (factor 1) con mas existencia. Si no hay
  // de piezas no se adivina la presentacion: regresa null.
  function varianteDelMaster(master) {
    const variantes = inventarios.filter(
      (inv) => !inv.esMaster && String(inv.idPadre) === String(master.idArticulo)
    );
    if (variantes.length === 1) return variantes[0];
    return (
      variantes
        .filter((inv) => (parseFloat(inv.piezasPorCaja) || 1) === 1)
        .sort((a, b) => (parseFloat(b.cantidad) || 0) - (parseFloat(a.cantidad) || 0))[0] || null
    );
  }

  // Primero match exacto contra el SKU que se leyo del PDF (el SKU del sistema o el codigo con el que se
  // publico en MeLi); si no cuadra se cae a buscar cual SKU del inventario aparece dentro del renglon
  // (gana el mas largo). Si lo que cuadra es un master, se toma de su variante.
  function resolverInventario(fila) {
    const norm = (s) => (s || "").toString().toUpperCase().replace(/\s+/g, "");
    const s1 = norm(fila.sku);
    const s2 = norm(fila.skuAlt);
    const claves = (inv) => [skuDeInv(inv), inv.codigoOrigen].map(norm).filter(Boolean);
    // las variantes primero: comparten SKU con su master
    const ordenados = [...inventarios.filter((inv) => !inv.esMaster), ...inventarios.filter((inv) => inv.esMaster)];
    const aVariante = (inv) => (inv && inv.esMaster ? varianteDelMaster(inv) : inv);

    if (s1 || s2) {
      const exacto = ordenados.find((inv) => claves(inv).some((n) => n === s1 || n === s2));
      if (exacto) return aVariante(exacto);
    }

    const desdeSKU = (t) => {
      const i = t.toUpperCase().lastIndexOf("SKU:");
      return i >= 0 ? t.slice(i + 4) : t;
    };
    const b1 = norm(desdeSKU(fila.blob));
    const b2 = norm(desdeSKU(fila.blobSp));

    let mejor = null;
    let largo = 0;
    for (const inv of ordenados) {
      for (const n of claves(inv)) {
        if (n.length < 3 || n.length <= largo) continue;
        if (b1.includes(n) || b2.includes(n)) {
          mejor = inv;
          largo = n.length;
        }
      }
    }
    return aVariante(mejor);
  }

  async function importarPDFFull(event) {
    const file = event.target.files && event.target.files[0];
    if (!file) return;
    event.target.value = ""; // permite volver a subir el mismo archivo

    if (!selectedAreaSalida) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Selecciona primero el almacen de salida",
      });
      return;
    }
    if (!inventarios.length) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "El almacen de salida no tiene inventario cargado",
      });
      return;
    }

    setCargando(true);
    try {
      const buffer = await file.arrayBuffer();
      const filas = await leerRenglonesPDF(new Uint8Array(buffer));

      if (!filas.length) {
        setCargando(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "No se detectaron renglones. Verifica que sea el PDF de preparacion de MeLi Full.",
        });
        return;
      }

      // Un mismo articulo puede venir en varios renglones: se acumulan
      const porArticulo = {};
      const noEncontrados = [];

      filas.forEach((f) => {
        const inv = resolverInventario(f);
        if (!inv) {
          noEncontrados.push(f.sku || "(sin SKU)");
          return;
        }
        if (!porArticulo[inv.idArticulo]) {
          porArticulo[inv.idArticulo] = { inv, cantidad: 0 };
        }
        porArticulo[inv.idArticulo].cantidad += f.cantidad;
      });

      const encontrados = Object.values(porArticulo);
      const sinStock = encontrados.filter(
        (e) => e.cantidad > (parseFloat(e.inv.cantidad) || 0)
      );

      const nuevos = encontrados.map((e) => {
        const pxc = parseFloat(e.inv.piezasPorCaja) || 1;
        const precio = e.inv.precio || 0;
        return {
          id: uuidv4(),
          articulos: e.inv.idArticulo,
          inventarioId: e.inv._id,
          piezasPorCaja: e.inv.piezasPorCaja,
          cajas: (e.cantidad / pxc).toFixed(2),
          cantidad: e.cantidad,
          precio,
          costoUnitario: e.inv.costoUnitario || 0,
          lote: e.inv.lote || "NA",
          total: e.cantidad * precio,
          disponible: e.inv.cantidad || 0,
          infoAdicional: "NA",
          // El Autocomplete no muestra seleccion cargada por codigo, asi que el
          // SKU va en su propia columna para que el renglon sea identificable
          sku: skuDeInv(e.inv),
          nombreArticulo: e.inv.nombre || "",
        };
      });

      if (nuevos.length) {
        setInputFields(nuevos);
        ActualizaTotalesFrom(nuevos);
      }
      setCargando(false);

      const totalPDF = filas.reduce((t, f) => t + f.cantidad, 0);
      const totalCargado = encontrados.reduce((t, e) => t + e.cantidad, 0);

      const msgs = [
        `✅ <b>${filas.length}</b> renglon(es) leidos del PDF · <b>${totalPDF}</b> unidades`,
        `📦 <b>${nuevos.length}</b> articulo(s) cargados · <b>${totalCargado}</b> unidades`,
      ];
      if (sinStock.length) {
        msgs.push(
          `⚠️ <b>${sinStock.length}</b> con cantidad mayor al disponible (se cargan y quedarán en negativo en el almacén de salida):<br><ul>${sinStock
            .map(
              (e) =>
                `<li><b>${skuDeInv(e.inv)}</b> — PDF: ${e.cantidad}, disponible: ${e.inv.cantidad}</li>`
            )
            .join("")}</ul>`
        );
      }
      if (noEncontrados.length) {
        msgs.push(
          `❌ <b>${noEncontrados.length}</b> SKU sin match en este almacen (o master con varias presentaciones, elige la variante a mano):<br>${noEncontrados
            .slice(0, 20)
            .join(", ")}${noEncontrados.length > 20 ? "..." : ""}`
        );
      }

      Swal.fire({
        title: "PDF procesado",
        html: msgs.join("<br><br>"),
        icon: noEncontrados.length || sinStock.length ? "warning" : "success",
        width: 700,
      });
    } catch (error) {
      console.log(error);
      setCargando(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No se pudo leer el PDF",
        footer: `${error.message || ""}`,
      });
    }
  }

  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: "",
        inventarioId: "",
        piezasPorCaja: 0,
        cajas: 0,
        cantidad: 0,
        precio: 0,
        costoUnitario: 0,
        lote: "NA",
        total: 0,
        disponible: 0,
        infoAdicional: "NA",
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    ActualizaTotalesFrom(values);
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.infoAdicional = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
  };

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      // Sale aunque no alcance la existencia (queda en negativo); al guardar se avisa cuales
      if (id === i.id) {
        i.cantidad = event.target.value;
        i.cajas = (
          parseFloat(event.target.value) / parseFloat(i.piezasPorCaja)
        ).toFixed(2);
        i.total = i.cantidad * i.precio;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotalesFrom(newInputFields);
  };

  function BuscaArticulo(id, seleccionado) {
    if (!seleccionado) return;
    // Un master se surte de su variante (el renglon del master no es un registro de inventario)
    const selectedArticulo = seleccionado.esMaster ? varianteDelMaster(seleccionado) : seleccionado;
    if (!selectedArticulo) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `${seleccionado.SKU} tiene varias presentaciones: elige la variante`,
      });
      return;
    }

    if (
      inputFields.filter(
        (e) => e.articulos === selectedArticulo.idArticulo
      ).length > 0
    ) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "El modelo ya fue capturado!",
        showConfirmButton: false,
      });
      const newInputFields = inputFields.map((i) => {
        if (id === i.id) {
          i.articulos = "";
        }
        return i;
      });
      setInputFields(newInputFields);
      return;
    }

    const matchInv = inventarios.find(
      (a) => a.idArticulo === selectedArticulo.idArticulo
    );
    if (!matchInv) return;

    handleChangeInputArticulo(id, matchInv);
  }

  const handleChangeInputArticulo = (id, inv) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = inv.idArticulo;
        i.inventarioId = inv._id;
        i.piezasPorCaja = inv.piezasPorCaja;
        i.precio = inv.precio || 0;
        i.costoUnitario = inv.costoUnitario || 0;
        i.lote = inv.lote || "NA";
        i.disponible = inv.cantidad || 0;
        i.total = i.cantidad * i.precio;
        i.sku = skuDeInv(inv);
        i.nombreArticulo = inv.nombre || "";
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotalesFrom(newInputFields);
  };

  function ActualizaTotalesFrom(fields) {
    const TK = fields
      .map((c) => parseFloat(c.cantidad) || 0)
      .reduce((t, v) => t + v, 0);
    setTotalCantidad(TK);
    const TG = fields
      .map((c) => parseFloat(c.total) || 0)
      .reduce((t, v) => t + v, 0);
    setTotal(TG);
  }

  const options = inventarios.map((option) => {
    const sku = option.SKU || option.codigo || "";
    // tambien se encuentra por el SKU de MeLi (codigoOrigen)
    const junta = sku + (option.codigoOrigen ? ` ${option.codigoOrigen} ` : "") + (option.nombre || "");
    const firstLetter = ((sku || "X")[0] || "X").toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      SKU: sku,
      junta,
    };
  });

  return (
    <>
      <Header />
      <br />
      <br />
      {user.traspasos_salida_create ? (
        <div className="card container col-12">
          <h3 align="center">Nuevo Traspaso (Salida + Entrada en un paso)</h3>
          <Row>
            <Col md={2}>
              <Label>Fecha</Label>
              <Input
                type="date"
                placeholder="Fecha"
                value={fecha}
                required
                disabled
              />
            </Col>

            <Col md={2}>
              <Label>Fecha Recolección</Label>
              <Input
                type="date"
                placeholder="Fecha Recolección"
                value={fechaRecoleccion}
                onChange={(e) => setFechaRecoleccion(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>Surtir de Almacén</Label>
              <Input
                type="select"
                value={selectedAreaSalida}
                onChange={(e) => {
                  jalaAlmacenSalida(e.target.value);
                }}
              >
                <option value="">Selecciona un almacén</option>
                {areas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    if (a._id !== AREAS_GENERAL) {
                      return <option value={a._id}>{a.name}</option>;
                    }
                  })}
              </Input>
            </Col>

            <Col md={3}>
              <Label className="mr-sm-2">Almacén Destino</Label>
              {user.areas === AREAS_GENERAL ? (
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedAreaDestino}
                  required
                  onChange={(e) => {
                    setSelectedAreaDestino(e.target.value);
                  }}
                >
                  <option value="">Almacén Destino</option>
                  {areas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      if (a._id !== AREAS_GENERAL) {
                        return <option value={a._id}>{a.name}</option>;
                      }
                    })}
                </Input>
              ) : (
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedAreaDestino}
                  required
                  onChange={(e) => {
                    setSelectedAreaDestino(e.target.value);
                  }}
                >
                  <option value="">Almacén Destino</option>
                  {areas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      if (user.areas === a._id) {
                        return <option value={a._id}>{a.name}</option>;
                      }
                    })}
                </Input>
              )}
            </Col>

            <Col md={2}>
              <Label>Piezas</Label>
              <Input
                type="number"
                min="0"
                step="any"
                placeholder="Piezas"
                value={total_cantidad}
                required
                disabled
              />
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Label className="mr-sm-2">Observaciones</Label>
              <Input
                type="text"
                placeholder="Observaciones"
                value={observaciones}
                required
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col>
          </Row>
          <br />

          <Row>
            <Col md={4}>
              <Label className="mr-sm-2">
                Cargar desde PDF de MeLi Full
              </Label>
              <Input
                type="file"
                name="filePDF"
                id="filePDF"
                accept="application/pdf,.pdf"
                onChange={(event) => importarPDFFull(event)}
                disabled={!selectedAreaSalida || cargando}
              />
              <small style={{ color: "#64748b", fontSize: "0.7rem" }}>
                {selectedAreaSalida
                  ? "Listado de productos e instrucciones de preparación. Reemplaza los renglones capturados."
                  : "Selecciona primero el almacén de salida."}
              </small>
            </Col>
          </Row>
          <br />

          <Row>
            <Col md={3}>
              <Label className="mr-sm-2">Artículo</Label>
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">SKU</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Disponible</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Piezas / Caja</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Cantidad</Label>
            </Col>
            {/* <Col md={2}>
              <Label className="mr-sm-2">Info Adicional</Label>
            </Col> */}
          </Row>

          {inputFields.map((inputField) => (
            <div key={inputField.id}>
              <Row>
                <Col md={3}>
                  <Autocomplete
                    size="small"
                    value={inputField.articulosNombre}
                    onChange={(event, selectedArticulo) => {
                      BuscaArticulo(inputField.id, selectedArticulo);
                    }}
                    options={options.sort(
                      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                    )}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option.junta}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Selecciona"
                        variant="outlined"
                      />
                    )}
                    renderOption={(option) => (
                      <React.Fragment>
                        {option.SKU} {option.codigoOrigen ? `(${option.codigoOrigen}) ` : ""}
                        {option.esMaster ? "[MASTER] " : ""}
                        {option.nombre}
                      </React.Fragment>
                    )}
                  />
                </Col>
                <Col md={3}>
                  <Input
                    name="sku"
                    type="text"
                    value={inputField.sku || ""}
                    placeholder="SKU"
                    title={inputField.nombreArticulo || ""}
                    disabled
                    style={{ fontWeight: 600, color: "#0369a1" }}
                  />
                </Col>
                <Col md={1}>
                  <Input
                    name="disponible"
                    type="number"
                    min="0"
                    step="any"
                    value={inputField.disponible}
                    required
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    name="piezasPorCaja"
                    type="number"
                    min="0"
                    step="any"
                    value={inputField.piezasPorCaja}
                    required
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    name="cantidad"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Cantidad"
                    value={inputField.cantidad}
                    required
                    onChange={(event) =>
                      handleChangeInputCantidad(inputField.id, event)
                    }
                  />
                </Col>
                {/* <Col md={2}>
                  <Input
                    name="infoAdicional"
                    type="text"
                    step="any"
                    placeholder="infoAdicional"
                    value={inputField.infoAdicional}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col> */}
                <Col>
                  <Button
                    size="sm"
                    className="btn"
                    color="danger"
                    disabled={inputFields.length === 1}
                    onClick={() => handleRemoveFields(inputField.id)}
                    tabindex="-1"
                  >
                    <i class="fas fa-minus"></i>
                  </Button>
                  <Button
                    size="sm"
                    className="btn"
                    color="info"
                    onClick={handleAddFields}
                  >
                    <i class="fas fa-plus"></i>
                  </Button>
                </Col>
              </Row>
            </div>
          ))}
          <br />
          <Row>
            <Col md={1}>
              {validaBoton ? (
                <Button
                  type="submit"
                  className="btn btn-success"
                  tabindex="-1"
                  onClick={saveTraspaso}
                >
                  Guardar
                </Button>
              ) : (
                <Button type="submit" className="btn btn-success" disabled>
                  Guardar
                </Button>
              )}
            </Col>
            <Col md={1}>
              <Button
                href="/ListadoTraspasosSalida"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
          </Row>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{ width: "50px", height: "50px", color: "#232B41" }}
                />
                <Spinner
                  style={{ width: "50px", height: "50px", color: "#232B41" }}
                />
                <Spinner
                  style={{ width: "50px", height: "50px", color: "#232B41" }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default TraspasosSalidaCreate;
